import styled from "styled-components";
import { card, navyCard } from "../../../../style/styled-components/mixins";
// 납세자 권리보호 제도 구조도. 예전에는 절대좌표 선 긋기로 그렸지만,
// 문구는 그대로 두고 사전·사후 구제 두 트랙의 카드 흐름으로 다시 그린다.
const TASProcess = () => {
  return (
    <Div>
      <div className="root">권리보호제도</div>
      <div className="tracks">
        <section>
          <h4>사전구제제도</h4>
          <div className="node">과세전 적부심사</div>
        </section>
        <section>
          <h4>사후구제제도</h4>
          <ol>
            <li>
              <div className="node">이의신청</div>
              <p>원하는 경우에만 신청(생략 가능)</p>
            </li>
            <li>
              <div className="options">
                <div className="node">심사청구(관세청장)</div>
                <div className="node">심사청구(감사원장)</div>
                <div className="node">심판청구(조세심판원)</div>
              </div>
              <p>中 택1</p>
            </li>
            <li>
              <div className="node">행정소송</div>
              <p>
                행정심판 전치주의에 따라
                <br />
                심사청구 또는 심판청구 중 하나를 거쳐야 함
              </p>
            </li>
          </ol>
        </section>
      </div>
    </Div>
  );
};
export default TASProcess;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  & > .root {
    ${navyCard}
    align-self: center;
    min-width: min(20rem, 100%);
    padding: 1rem 2.5rem;
    text-align: center;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: -0.01em;
  }
  & > .tracks {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
    gap: 1rem;
    @media (max-width: 767px) {
      grid-template-columns: minmax(0, 1fr);
    }
    & > section {
      ${card}
      position: relative;
      overflow: hidden;
      margin: 0;
      padding: 1.5rem 1.5rem 1.75rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
      }
      & > h4 {
        margin: 0 0 1.25rem;
        font-size: 1.05rem;
        font-weight: 800;
        color: ${({ theme }) => theme.colors.dark};
      }
      & .node {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 3.25rem;
        padding: 0.6rem 1.25rem;
        border-radius: ${({ theme }) => theme.radius};
        border: 1px solid ${({ theme }) => theme.colors.line};
        background-color: ${({ theme }) => theme.colors.accentSoft};
        font-weight: 700;
        text-align: center;
        color: ${({ theme }) => theme.colors.dark};
      }
      & p {
        margin: 0.5rem 0 0;
        font-size: 0.85rem;
        line-height: 1.55;
        text-align: center;
        color: ${({ theme }) => theme.colors.foreground.dimmed};
      }
      & > ol {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > li {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          /* 단계 사이 ↓ 화살표 */
          & + li:before {
            content: "↓";
            margin: 0.6rem 0;
            font-size: 1.1rem;
            font-weight: 800;
            color: ${({ theme }) => theme.colors.accent};
          }
          & > .node {
            min-width: min(14rem, 100%);
          }
          & > .options {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 0.75rem;
            @media (max-width: 575px) {
              grid-template-columns: minmax(0, 1fr);
            }
            & > .node {
              font-size: 0.95rem;
            }
          }
        }
      }
    }
  }
`;
